module.exports = __webpack_public_path__ + "static/media/logohocohorizontal.e946cb12.png";